// Theme choice (DESIGN_SYSTEM §12.1): follow the OS by default; an explicit choice sets
// data-theme on <html>. Stored per device (a convenience, not account data).
export type ThemeChoice = "system" | "light" | "dark";
const KEY = "ady.theme";

export function readTheme(): ThemeChoice {
  try {
    const v = localStorage.getItem(KEY);
    return v === "light" || v === "dark" ? v : "system";
  } catch {
    return "system";
  }
}

/**
 * Forces the light theme while a screen is shown (log in and sign-up are always light, owner
 * 2026-10-21), without touching the stored choice; returns the undo that restores it.
 */
export function forceLight(): () => void {
  const root = document.documentElement;
  root.setAttribute("data-theme", "light");
  return () => {
    const choice = readTheme();
    if (choice === "system") root.removeAttribute("data-theme");
    else root.setAttribute("data-theme", choice);
  };
}

/** The Code editor tab is always dark (owner, 2026-10-26); same undo as forceLight. */
export function forceDark(): () => void {
  const undo = forceLight();
  document.documentElement.setAttribute("data-theme", "dark");
  return undo;
}

export function applyTheme(choice: ThemeChoice): void {
  const root = document.documentElement;
  if (choice === "system") root.removeAttribute("data-theme");
  else root.setAttribute("data-theme", choice);
  try {
    if (choice === "system") localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, choice);
  } catch {
    // Storage blocked (private mode): the choice lasts for this page only.
  }
}
